import { render, staticRenderFns } from "./redirect-act-index.vue?vue&type=template&id=07013939&scoped=true"
import script from "./redirect-act-index.vue?vue&type=script&lang=js"
export * from "./redirect-act-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07013939",
  null
  
)

export default component.exports